export default "assets/images/icons/fleche-next-3188ce5c.svg";